module.exports = __webpack_public_path__ + "img/5b72a9a700b20db128bc60ca209f15f1.1f3c763d.jpg";